
ADILF.define('less/less',['require', 'css'], function(require, cssAPI) {
  
  var lessAPI = {};
  
  lessAPI.pluginBuilder = './less-builder';
  
  if (typeof window == 'undefined') {
    lessAPI.load = function(n, r, load) { load(); }
    return lessAPI;
  }
  
  lessAPI.normalize = function(name, normalize) {
    if (name.substr(name.length - 5, 5) == '.less')
      name = name.substr(0, name.length - 5);

    name = normalize(name);

    return name;
  }
  
  var head = document.getElementsByTagName('head')[0];

  var base = document.getElementsByTagName('base');
  base = base && base[0] && base[0] && base[0].href;
  var pagePath = (base || window.location.href.split('#')[0].split('?')[0]).split('/');
  pagePath[pagePath.length - 1] = '';
  pagePath = pagePath.join('/');

  var styleCnt = 0;
  var curStyle;
  lessAPI.inject = function(css) {
    if (styleCnt < 31) {
      curStyle = document.createElement('style');
      curStyle.type = 'text/css';
      head.appendChild(curStyle);
      styleCnt++;
    }
    if (curStyle.styleSheet)
      curStyle.styleSheet.cssText += css;
    else
      curStyle.appendChild(document.createTextNode(css));
  }

  // If config.less.browserLoad is set, then the user does not want to 
  // run less.js in the browser. They just want to include another,
  // probably already built, css file.
  var insertedBrowerLoad = false;

  lessAPI.load = function(lessId, req, load, config) {
    var lessConfig = window.less = config.less || {};
    window.less.env = 'development';

    if (lessConfig.browserLoad) {
      if ( ! insertedBrowerLoad) {
        insertedBrowerLoad = true;
        config.css.transform = false;
        return cssAPI.load(lessConfig.browserLoad, req, load, config);        
      }
      return load();
    }

    require(['./lessc', './normalize'], function(lessc, normalize) {

      var fileUrl = req.toUrl(lessId + '.less');
      fileUrl = normalize.absoluteURI(fileUrl, pagePath);

      var parser = new lessc.Parser(window.less);

      parser.parse('@import (multiple) "' + fileUrl + '";', function(err, tree) {
        if (err)
          return load.error(err);

        lessAPI.inject(normalize(tree.toCSS(config.less), fileUrl, pagePath));

        setTimeout(load, 7);
      });

    });
  }
  
  return lessAPI;
});

ADILF.define('less', ['less/less'], function (main) { return main; });
